import { Middleware } from "@reduxjs/toolkit";
import { RootState } from "../index";
import {
  setHullConfiguration,
  setSpecializedHull,
  setAdditionalHull,
  setHullAndArmorStats,
  setDriveStats,
  setDriveWithValidation,
  setPowerPlant,
  setBridge,
  setSensors,
  setArmor,
  setWeapons,
  setCargo,
  setFuel,
  setFuelTanks,
  setStateroomConfig,
  updateShipStats,
  setHull,
  setDrives,
  setDrive,
  addDrive,
  removeDrive,
  updateDriveRole,
} from "../features/shipBuilderSlice";
import { 
  addPowerSystem, 
  removePowerSystem
} from "../features/optionalSystemsSlice";
import { removeOptionalSystem, addOptionalSystem } from "../features/shipBuilderSlice";
import { calculateShipStats } from "../../utils/calculations/shipCalculations";

const shipStatsMiddleware: Middleware<{}, RootState> =
  (store) => (next) => (action: any) => {
    const result = next(action);

    // After the state is updated, recalculate the ship's aggregate stats.
    // This should run after any component that affects cost or weight is updated.
    if (
      setHullConfiguration.match(action) ||
      setSpecializedHull.match(action) ||
      setAdditionalHull.match(action) ||
      setHullAndArmorStats.match(action) ||
      setDriveStats.match(action) ||
      setDriveWithValidation.match(action) ||
      setPowerPlant.match(action) ||
      setBridge.match(action) ||
      setSensors.match(action) ||
      setArmor.match(action) ||
      setWeapons.match(action) ||
      setCargo.match(action) ||
      setFuel.match(action) ||
      setFuelTanks.match(action) ||
      setStateroomConfig.match(action) ||
      setHull.match(action) ||
      setDrives.match(action) ||
      setDrive.match(action) ||
      addDrive.match(action) ||
      removeDrive.match(action) ||
      updateDriveRole.match(action) ||
      addPowerSystem.match(action) ||
      removePowerSystem.match(action) ||
      addOptionalSystem.match(action) ||
      removeOptionalSystem.match(action)
    ) {
      console.log("📊 shipStatsMiddleware: Triggered by action:", action.type);
      const state = store.getState().shipBuilder;
      console.log("📊 shipStatsMiddleware: Current state.sensors:", state.sensors);

      // Skip calculation if state is not properly initialized
      // Allow calculation if bridge is selected even if hull is not configured
      if ((!state.shipSize || state.shipSize <= 0 || !state.hull) && !state.bridge) {
        console.log("shipStatsMiddleware: Skipping calculation - state not initialized and no bridge selected");
        return result;
      }

      // Skip calculation if hull is in initial unconfigured state (cost is 0)
      // This prevents calculating costs for the default hull configuration
      // Exception: Allow calculation if bridge is selected (auto-selected bridge should be included in costs)
      if (state.hull && state.hull.cost === 0 && !state.bridge) {
        console.log("shipStatsMiddleware: Skipping calculation - hull not yet configured by user and no bridge selected");
        return result;
      }

      // Use the comprehensive calculateShipStats function to get all costs including drives
      const shipStatsResult = calculateShipStats(state, store.getState().optionalSystems);
      console.log("📊 shipStatsMiddleware: Calculation result:", shipStatsResult);
      console.log("📊 shipStatsMiddleware: shipStatsResult.data.totalCost:", shipStatsResult.data?.totalCost);

      if (shipStatsResult.success && shipStatsResult.data) {
        console.log("📊 shipStatsMiddleware: Dispatching updateShipStats with totalCost:", shipStatsResult.data.totalCost);
        store.dispatch(updateShipStats(shipStatsResult.data));
      }
    }

    return result;
  };

export default shipStatsMiddleware;
